"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));
function SzDebit(_a) {
    var validation = _a.validation, content = _a.content, info = _a.info;
    var iconClasses = classnames_1.default('sz-line-height-normal big', {
        'text-primary': validation,
        'text-danger': !validation
    });
    var icon = validation ? 'check' : 'remove';
    return (react_1.default.createElement("div", { className: "d-flex bg-secondary p-3" },
        react_1.default.createElement("div", { className: "mr-3 bg-white rounded-circle p-4 sz-border-11 border-light" },
            react_1.default.createElement(SzIcon_1.default, { icon: icon, variant: "bold", className: iconClasses })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: "sz-big-font-size sz-line-height-normal text-primary" }, content),
            react_1.default.createElement("p", { className: "sz-normal-font-size text-white" }, info))));
}
exports.default = SzDebit;
